import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import { UserApi } from 'api/user';
import { changeZoneMappingConfig } from 'store/feature/userSlice';
import { RootState } from 'store';

type SelectOption = { value: string | null; label: string };

const panelContainerStyle: React.CSSProperties = {
    textAlign: 'left',
    display: 'inline-grid',
    lineHeight: '1.5',
    marginTop: '5px',
    marginLeft: '50px',
    width: '150px',
};

const NONE_OPTION: SelectOption = { value: null, label: 'None' };

interface Props {
    datasetId: number;
}

const ZoneMappingConfigPanelItems = ({ datasetId }: Props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const zoneMappingId = useSelector(
        (state: RootState) =>
            state.user.uiSettings?.zoneMappingConfig?.id ?? null
    );
    const [configs, setConfigs] = useState<UserApi.ZoneMappingConfigOption[]>(
        []
    );
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!datasetId) return;
        setLoading(true);
        UserApi.fetchZoneMappingConfigs(datasetId)
            .then(setConfigs)
            .catch((err) =>
                console.error('Failed to fetch zone mapping configs', err)
            )
            .finally(() => setLoading(false));
    }, [datasetId]);

    const options: SelectOption[] = [
        NONE_OPTION,
        ...configs.map((c) => ({ value: c.id, label: c.name })),
    ];

    const selectedOption =
        options.find((o) => o.value === zoneMappingId) ?? NONE_OPTION;

    const handleChange = async (option: SingleValue<SelectOption>) => {
        try {
            await dispatch(changeZoneMappingConfig(option?.value ?? null));
            history.push(history.location.pathname + history.location.search);
        } catch (err) {
            console.error('Failed to change zone mapping config', err);
        }
    };

    return (
        <div style={panelContainerStyle}>
            <Select
                className="basic-single"
                classNamePrefix="list"
                isSearchable={false}
                isLoading={loading}
                options={options}
                value={selectedOption}
                onChange={handleChange}
                menuPlacement="auto"
                placeholder="None"
            />
        </div>
    );
};

export default ZoneMappingConfigPanelItems;
